import { render, staticRenderFns } from "./CardCommentItem.vue?vue&type=template&id=186dd0be&"
import script from "./CardCommentItem.vue?vue&type=script&lang=js&"
export * from "./CardCommentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports